// Event-triggered, single-flight refresh. Retries errors, never polls after success.
export default class SnapshotRefresher {
  #load;
  #scheduler;
  #retryDelay;
  #running;
  #pending;
  #disposed;
  #failures;
  #timer;
  constructor({ load, scheduler, retryDelay }) {
    this.#load = load;
    this.#scheduler = scheduler;
    this.#retryDelay = retryDelay;
    this.#running = false;
    this.#pending = false;
    this.#disposed = false;
    this.#failures = 0;
    this.#timer = null;
  }

  request() {
    if (this.#disposed) return;
    this.#pending = true; this.#scheduler.clear(this.#timer);
    if (!this.#running) this.#timer = this.#scheduler.set(() => this.#run(), 50);
  }

  async #run() {
    if (this.#disposed || this.#running) return;
    this.#running = true; this.#pending = false;
    try {
      if (await this.#load() === false) throw new Error('Snapshot unavailable');
      this.#failures = 0;
    } catch { this.#pending = true; this.#failures += 1; }
    finally {
      this.#running = false;
      if (!this.#disposed && this.#pending) {
        this.#timer = this.#scheduler.set(() => this.#run(), this.#failures ? this.#retryDelay(this.#failures) : 50);
      }
    }
  }

  dispose() { this.#disposed = true; this.#scheduler.clear(this.#timer); }
}
